import { Grid, styled } from '@mui/material';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { RenderUnsettledUI } from 'shared/components';
import { BlockLink, BlockProps, LwBlock, LwBlockGridContainer } from 'redesign';
import { Companies, GetCompaniesResponse } from 'api/services/company/company-service.schema';
import { UseInfiniteQueryResult } from 'react-query';

import { CompaniesFilterParams } from './companies.types';
import { routes } from '../../../../Routes';
import { IconBranchOffices } from '../../../../assets/img';
import { routePrefix } from '../../../../ogp/settings';

type CompaniesListProps = {
  params: CompaniesFilterParams;
  companiesQuery: UseInfiniteQueryResult<GetCompaniesResponse>;
  flatData: Companies;
  isInitialLoading: boolean;
};

export const CompaniesList = ({
  params,
  companiesQuery,
  flatData,
  isInitialLoading,
}: CompaniesListProps) => {
  if (companiesQuery.isError) {
    return <RenderUnsettledUI data={companiesQuery} />;
  }

  if (isInitialLoading) {
    return <RenderUnsettledUI data={companiesQuery} />;
  }

  return <CompaniesImpl data={flatData} filter={params.filter} />;
};

const CompaniesImpl = ({ data, filter }: { data: Companies; filter: string | undefined }) => {
  const generatePath = useHqRelativePath();
  const queryParams = filter ? { filter } : undefined;

  const blocks: BlockProps[] = data.map((block) => {
    return {
      id: block.id,
      title: block.name,
      chipLabels: [
        ...(block.offersFreelanceWork ? ['Freelance'] : []),
        ...(block.offersTempWork ? ['Uitzendkracht'] : []),
        ...(block.offersEmployeeWork ? ['Werknemer'] : []),
      ],
    };
  });

  return (
    <LwBlockGridContainer>
      {blocks.map((block) => (
        <Grid item xs={6} md={4} lg={3} key={block.id} aria-label="block-element">
          <BlockLink to={generatePath(routes.CompanyDetail, { id: block.id }, queryParams)}>
            <LwBlock
              icon={<StyledIconBranchOffices />}
              id={block.id}
              title={block.title}
              chipLabels={block.chipLabels}
              dataBlocks={block.dataBlocks}
              navigateCallback={(event) => {
                event.stopPropagation();
                event.preventDefault();
                window.open(`${routePrefix}/${block.id}/dashboard`);
              }}
              navigateLabel="Naar portal"
            />
          </BlockLink>
        </Grid>
      ))}
    </LwBlockGridContainer>
  );
};

const StyledIconBranchOffices = styled(IconBranchOffices)(() => ({
  width: '24px',
  height: '24px',
}));
